// NOTE: This is a generated file, nothing you do here matters
// The source of the all.svg file is located at './src/all.svg'
// The script that generates this file is located at tools/svg-generator.js
// To rebuild this file run 'yarn run generate-svgs'
import React from 'react';

export default {
  'ic-add': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <use xlinkHref="#ic-add" />
    </svg>
  ),
  'ic-arrow': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78 37">
      <use xlinkHref="#ic-arrow" />
    </svg>
  ),
  'ic-calculator-large': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91 95">
      <use xlinkHref="#ic-calculator-large" />
    </svg>
  ),
  'ic-calculator-small': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <use xlinkHref="#ic-calculator-small" />
    </svg>
  ),
  'ic-close': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <use xlinkHref="#ic-close" />
    </svg>
  ),
  'ic-dropdown-arrow': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <use xlinkHref="#ic-dropdown-arrow" />
    </svg>
  ),
  'ic-exclamation': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <use xlinkHref="#ic-exclamation" />
    </svg>
  ),
  'ic-info-white': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <use xlinkHref="#ic-info-white" />
    </svg>
  ),
  'ic-info': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <use xlinkHref="#ic-info" />
    </svg>
  ),
  'ic-logo': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 196 34">
      <use xlinkHref="#ic-logo" />
    </svg>
  ),
  'ic-present': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
      <use xlinkHref="#ic-present" />
    </svg>
  ),
  'ic-recommended': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 48">
      <use xlinkHref="#ic-recommended" />
    </svg>
  ),
  'ic-search': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <use xlinkHref="#ic-search" />
    </svg>
  ),
  'ic-tick-blue': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <use xlinkHref="#ic-tick-blue" />
    </svg>
  ),
  'ic-tick-grey': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <use xlinkHref="#ic-tick-grey" />
    </svg>
  ),
  'ic-tick': (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <use xlinkHref="#ic-tick" />
    </svg>
  ),
};
